import { newsFlash } from "@/mocks/newsFlash";
import SectionHeading from "./SectionHeading";

const tagStyles: Record<string, string> = {
  开箱速报: "bg-primary-100 text-primary-800",
  试吃记录: "bg-accent-100 text-accent-800",
  惊喜发现: "bg-secondary-100 text-secondary-800",
  科普: "bg-background-200 text-foreground-700",
};

export default function Flash() {
  return (
    <section id="flash" className="w-full">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="开箱速报"
          title="最近的盲盒开箱记录"
          desc="按时间倒序整理每一次开箱里最值得记下的部分，包括新品到货、试吃对比和偶尔出现的小彩蛋。"
        />

        <div className="mt-8 grid gap-6 lg:grid-cols-3">
          <ul className="lg:col-span-2">
            {newsFlash.map((item, index) => (
              <li
                key={item.id}
                className={`flex flex-col gap-2 py-5 sm:flex-row sm:items-start sm:gap-5 ${
                  index !== 0 ? "border-t border-background-200" : ""
                }`}
              >
                <div className="flex w-full shrink-0 items-center gap-3 sm:w-40 sm:flex-col sm:items-start sm:gap-2">
                  <span
                    className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${
                      tagStyles[item.tag] ?? "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <div>
                  <h3 className="text-base font-medium leading-snug text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    {item.excerpt}
                  </p>
                </div>
              </li>
            ))}
          </ul>

          <aside className="rounded-lg border border-background-200 bg-background-100 p-5">
            <h3 className="flex items-center gap-2 font-heading text-base text-foreground-950">
              <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-calendar-2-line text-sm" />
              </span>
              更新节奏
            </h3>
            <ul className="mt-4 space-y-4">
              <li className="flex gap-3">
                <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center">
                  <i className="ri-checkbox-circle-line text-accent-600" />
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">每周三</p>
                  <p className="text-xs leading-relaxed text-foreground-600">
                    更新试吃记录与口味对比，主要是文字与打分。
                  </p>
                </div>
              </li>
              <li className="flex gap-3">
                <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center">
                  <i className="ri-checkbox-circle-line text-accent-600" />
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">每周六</p>
                  <p className="text-xs leading-relaxed text-foreground-600">
                    完整开箱，含图片、单品清单与本期惊喜款记录。
                  </p>
                </div>
              </li>
              <li className="flex gap-3">
                <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center">
                  <i className="ri-checkbox-circle-line text-accent-600" />
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">不定期</p>
                  <p className="text-xs leading-relaxed text-foreground-600">
                    遇到隐藏款或限定口味时，单独发一条速报。
                  </p>
                </div>
              </li>
            </ul>

            <div className="mt-5 rounded-md border border-accent-200 bg-accent-50 p-4">
              <p className="text-xs leading-relaxed text-accent-900">
                所有内容均为开箱与试吃的记录分享，用于帮助判断口味偏好，不涉及下单、支付或配送。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}